export default __webpack_public_path__ + "static/media/cohere-ui.6bffb5d4.png";